<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ (maintenanceTask ? 'maintenance.editTaskTitle' : 'maintenance.addTaskTitle') | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirm()" [strong]="true">
        {{ 'common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="app-page-container">

    <section class="app-section-card">
      <header class="app-section-header">
        <h3>{{ 'maintenance.form.detailsSection' | translate }}</h3>
      </header>

      <ion-item lines="none" class="form-item">
        <ion-label mode="ios" position="stacked">{{ 'maintenance.form.nameLabel' | translate }}</ion-label>
        <ion-input [(ngModel)]="maintenanceTaskDTO.name" maxlength="200"
          [placeholder]="'maintenance.form.namePlaceholder' | translate" />
      </ion-item>

      <ion-item lines="none" class="form-item">
        <ion-label mode="ios" position="stacked">{{ 'maintenance.form.descriptionLabel' | translate }}</ion-label>
        <ion-textarea [(ngModel)]="maintenanceTaskDTO.description" autocapitalize="sentences"
          enterkeyhint="next" inputmode="text" maxlength="2000" counter="true"
          [placeholder]="'maintenance.form.descriptionPlaceholder' | translate" rows="5"
          spellcheck="true" />
      </ion-item>
    </section>

    <section class="app-section-card">
      <header class="app-section-header">
        <h3>{{ 'maintenance.form.categorySection' | translate }}</h3>
      </header>

      @if (maintenanceTaskCategories.length === 0) {
        <p class="empty-categories" [innerHTML]="'maintenance.form.noCategories' | translate"></p>
      } @else {
        <ion-item lines="none" class="form-item">
          <ion-label mode="ios" position="stacked">{{ 'maintenance.form.categoryLabel' | translate }}</ion-label>
          <ion-select [(ngModel)]="maintenanceTaskDTO.maintenanceTaskCategoryId" interface="action-sheet">
            @for (category of maintenanceTaskCategories; track category) {
              <ion-select-option [value]="category.id">{{ category.name }}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      }
    </section>

    <section class="app-section-card">
      <header class="app-section-header">
        <h3>{{ 'maintenance.form.frequencySection' | translate }}</h3>
      </header>

      <div class="period-row">
        <span class="period-word">{{ 'maintenance.form.frequencyPrefix' | translate }}</span>
        <ion-input class="period-number" [(ngModel)]="maintenanceTaskDTO.periodNumber" type="number"
          inputmode="numeric" min="1" />
        <ion-select class="period-unit" [(ngModel)]="maintenanceTaskDTO.periodType"
          interface="action-sheet">
          <ion-select-option value="DAY">{{ 'maintenance.period.day' | translate }}</ion-select-option>
          <ion-select-option value="WEEK">{{ 'maintenance.period.week' | translate }}</ion-select-option>
          <ion-select-option value="MONTH">{{ 'maintenance.period.month' | translate }}</ion-select-option>
          <ion-select-option value="YEAR">{{ 'maintenance.period.year' | translate }}</ion-select-option>
        </ion-select>
        <span class="period-word">{{ 'maintenance.form.frequencySuffix' | translate }}</span>
      </div>
    </section>

    <div class="submit-row">
      <ion-button (click)="cancel()" fill="outline">{{ 'common.cancel' | translate }}</ion-button>
      <ion-button (click)="confirm()" [strong]="true" color="primary">
        {{ (maintenanceTask ? 'common.saveChanges' : 'common.add') | translate }}
      </ion-button>
    </div>

  </div>
</ion-content>
